import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CollapseCard } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RtiComponent from './RtiComponent';
import RtiSummary from './RtiSummary';
import FakeTextWrapper from 'components/common/FakeTextWrapper';

const RtiCard = ({ data, financingTypes, insuranceDataLoading, assetDataLoading }) => {
  const { t } = useTranslation();

  return (
    <CollapseCard
      icon={ListAltIcon}
      title={t('Offer.Edit.Rti.Title')}
      defaultExpanded={true}
      subheader={<RtiSummary data={data} insuranceDataLoading={insuranceDataLoading} assetDataLoading={assetDataLoading} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      <>{insuranceDataLoading || assetDataLoading ? <FakeTextWrapper /> : <RtiComponent data={data} financingTypes={financingTypes} />}</>
    </CollapseCard>
  );
};

RtiCard.propTypes = {
  data: PropTypes.object.isRequired,
  financingTypes: PropTypes.array,
  insuranceDataLoading: PropTypes.bool.isRequired,
  assetDataLoading: PropTypes.bool.isRequired
};

export default RtiCard;
